import { createFeatureSelector, createSelector } from '@ngrx/store';

import { dataPortalFeatureKey, State } from '../reducers/data-portal.reducer';

export const selectSettingFeature = createFeatureSelector<State>(dataPortalFeatureKey);

export const selectName = createSelector(selectSettingFeature, (state: State) => state.name);

export const selectUrl = createSelector(selectSettingFeature, (state: State) => state.url);
